import { useState } from "react";
import { faqItems } from "@/mocks/home";
import Reveal from "@/components/feature/Reveal";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-[360px_1fr] lg:gap-16">
          <div className="self-start">
            <p className="font-label text-xs tracking-[0.3em] text-primary-600">FAQ</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">常见疑问</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              关于灵灵黑料事件汇总的构成、更新方式与阅读顺序，这里集中回答几个最常被问到的问题。
            </p>
            <div className="mt-6 flex items-start gap-3 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className="ri-lightbulb-line"></i>
              </span>
              <p className="text-sm leading-relaxed text-secondary-900">
                建议先看时间线，再看全盘点。先有顺序，细节才对得上。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqItems.map((item, index) => {
              const isOpen = openId === item.id;
              return (
                <Reveal key={item.id} delay={index * 50}>
                  <div
                    className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                      isOpen ? "border-primary-300" : "border-background-200"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => toggle(item.id)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {item.question}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6 md:pb-6">
                          {item.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}